import { type UnityRichText } from '@@api/utils/schemas/schemas';

import isSerializedState from './isSerializedState';

// Issue #4120
// oxlint-disable-next-line typescript/no-explicit-any
const wrapSerializedState = (state: any): UnityRichText => {
    if (state == null || isSerializedState(state)) {
        return state;
    }

    if (Array.isArray(state)) {
        return {
            richTextFormat: state,
        };
    }

    return {
        richTextFormat: [state],
    };
};

export default wrapSerializedState;
